import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { StatmentCodeMappingRule } from './StatmentCodeMappingRule';

export default class StatmentCodeMappingRuleResource extends VersionedResource {
  public async getAll(fiId: string): Promise<StatmentCodeMappingRule[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/config/${fiId}/core-statement-code-mapping-rule`);
    const rules: StatmentCodeMappingRule[] = response.data.data;
    return rules;
  }

  public async save(fiId: string, rule: StatmentCodeMappingRule): Promise<StatmentCodeMappingRule> {
    const url = `/api/rcx/config/${fiId}/core-statement-code-mapping-rule`;
    let response: AxiosResponse;

    const toSave: any = {};
    Object.assign(toSave, rule);

    if (rule.id) {
      response = await this.apiClient.put(`${url}/${rule.id}`, toSave);
    } else {
      response = await this.apiClient.post(url, toSave);
    }

    const savedRule: StatmentCodeMappingRule = response.data.data;
    return savedRule;
  }

  public async remove(fiId: string, ruleId: number): Promise<AxiosResponse> {
    return this.apiClient.delete(`/api/rcx/config/${fiId}/core-statement-code-mapping-rule/${ruleId}`);
  }
}
